import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private subject = new Subject<any>();

  trigger(key: string, data?: any) {
    this.subject.next({ key, data });
  }

  subscribe(key: string, callback: (data?: any) => void | any): Subscription {
    return this.subject.asObservable().subscribe((event) => {
      if (event.key === key) {
        callback(event.data);
      }
    });
  }
}
